<!--  eslint-disable vue/no-v-text-v-html-on-component vue/no-v-html -->
<template>
  <div class="upsell-container">
    <x-icon v-if="displayIcon" icon="lock" />
    <x-body-text class="button-text" v-html="title"></x-body-text>
    <ys-button
      variant="primary"
      size="small"
      width="inline"
      data-test="discover-upgrade-button"
      @click="$emit('upgrade')"
    >
      Upgrade
    </ys-button>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import '@onxmaps/yellowstone-ui/ys-button'
import xIcon from '@/components/shared/x-icon'
import xBodyText from '@/components/shared/x-body-text'

export default {
  components: {
    xIcon,
    xBodyText,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    displayIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['upgrade'],
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';

.upsell-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: colors.$Grey20;
  padding: 16px 12px;
  border-radius: 12px;
  margin-bottom: 8px;

  .button-text {
    width: 183px;
    margin: 0 5px;
  }

  .x-button {
    margin: 0;
  }
}
</style>
